import React from 'react';
import './MScInAccountingAndFinance.css'; // Optional: Create a CSS file for styling

const MBAProgram = () => {
  return (
    <div className="msc-container" style={{ padding: '20px', maxWidth: '800px', marginTop: '160px',marginLeft:'50px' }}>
      <h1 style={{ textAlign: 'center' }}>📘 Master of Business Administration (MBA)</h1>

      <section>
        <h2 style={{ textAlign: 'center' }}>Program Overview</h2>
        <p>
          The Master of Business Administration (MBA) at Admas University is a comprehensive graduate program that prepares students for leadership roles in the public and private sectors. Designed for aspiring professionals and entrepreneurs, the MBA provides a solid foundation in business strategy, organizational management, finance, marketing, and innovation.
        </p>
      </section>

      <section>
        <h2>🎓 Program Objectives</h2>
        <ul>
          <li>To develop strategic thinking and leadership skills essential for dynamic business environments.</li>
          <li>To provide students with an understanding of global business practices and market trends.</li>
          <li>To equip graduates with the tools to manage organizations efficiently and responsibly.</li>
          <li>To promote ethical decision-making and social responsibility in business leadership.</li>
        </ul>
      </section>

      <section>
        <h2>📚 Core Courses</h2>
        <ul>
          <li>Managerial Economics</li>
          <li>Financial Management</li>
          <li>Marketing Strategy</li>
          <li>Organizational Behavior and Leadership</li>
          <li>Strategic Management</li>
          <li>Research Methods for Business</li>
          <li>Operations and Supply Chain Management</li>
          <li>Entrepreneurship and Innovation</li>
        </ul>
      </section>

      <section>
        <h2>🎓 Admission Requirements</h2>
        <ul>
          <li>Bachelor’s degree in any discipline from an accredited institution.</li>
          <li>Minimum GPA as required by the Ministry of Education or university policy.</li>
          <li>Professional work experience is an added advantage.</li>
          <li>Pass the Admas University postgraduate entrance exam.</li>
        </ul>
      </section>

      <section>
        <h2>🧭 Career Opportunities</h2>
        <p>
          MBA graduates can pursue executive positions in finance, human resources, operations, marketing, and general management. The program also supports entrepreneurs seeking to start or grow their own business ventures. Career paths include business consultant, project manager, CEO, marketing director, and more.
        </p>
      </section>

      <section>
        <h2>🏛️ Why Choose Admas University for Your MBA?</h2>
        <ul>
          <li>Highly qualified faculty with practical and academic experience.</li>
          <li>Evening and weekend class options for working professionals.</li>
          <li>Strong alumni network and business community partnerships.</li>
          <li>Modern teaching facilities and digital learning tools.</li>
          <li>Focus on innovation, ethical leadership, and local business development.</li>
        </ul>
      </section>
    </div>
  );
};

export default MBAProgram;